module.exports = __webpack_public_path__ + "static/media/header-bg.f1a95872.png";